import React from 'react';

class ResponsiveScreen extends React.Component {
    render() {
        return (
            <div className="responsive-screen">
                <img src="/assets/svg/responsive-message.svg" alt=""/>
            </div>
        );
    }
}

export default ResponsiveScreen;


// WEBPACK FOOTER //
// ./src/components/ResponsiveScreen.js